import { render, staticRenderFns } from "./UserItem.vue?vue&type=template&id=9db17982&"
import script from "./UserItem.vue?vue&type=script&lang=js&"
export * from "./UserItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VHover } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VListItemAvatar } from 'vuetify/lib'
import { VListItemContent } from 'vuetify/lib'
import { VListItemSubtitle } from 'vuetify/lib'
import { VListItemTitle } from 'vuetify/lib'
installComponents(component, {VCard,VHover,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle})
